import { Button, Checkbox, Col, Form, notification, Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { showErrors } from '../../../helpers/form';
import apiShipper from '../../../services/apiShipper';

export default function Parametrizacao({ cliente }) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [form] = Form.useForm();
  const [tipoLote, setTipoLote] = useState('TRANSPORTADORA');
  const [tmovTransportadora, setTmovTransportadora] = useState(true);
  const [anexoNfe, setAnexoNfe] = useState(false);

  useEffect(() => {
    async function onInit() {
      if (!cliente) return;

      const tipo_lote = cliente.tipo_lote ?? 'TRANSPORTADORA';
      const tmov_transportadora = cliente.tmov_transportadora ?? true;
      const anexo_nfe = !!cliente.anexo_nfe;

      setTipoLote(tipo_lote);
      setTmovTransportadora(tmov_transportadora);
      setAnexoNfe(anexo_nfe);

      form.setFieldsValue({
        tipoLote: tipo_lote,
        tmovTransportadora: tmov_transportadora,
        anexoNfe: anexo_nfe,
      });
    }

    onInit();
  }, [form, cliente, history]);

  const handleSubmitClient = async () => {
    setLoading(true);

    try {
      await apiShipper.put(`/clientes/${cliente.id}`, {
        ...cliente,
        tipo_lote: tipoLote,
        tmov_transportadora: tmovTransportadora,
        anexo_nfe: anexoNfe,
      });

      history.push('/clientes');

      notification.success({
        message: 'Tudo certo',
        description: 'O cliente foi atualizado com sucesso.',
      });
    } catch (error) {
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;

      showErrors(errors);
    } finally {
      setLoading(false);
    }
  };

  const onChangeTipoLote = event => {
    setTipoLote(event.target.value);
  };

  const onChangeTmovTransportadora = event => {
    setTmovTransportadora(event.target.checked);
  };

  const onChangeAnexoNfe = event => {
    setAnexoNfe(event.target.checked);
  };

  return (
    <>
      <Form layout="vertical" onFinish={handleSubmitClient} form={form}>
        <Row gutter={[0, 12]}>
          <Col span={24}>
            <Form.Item name="tmovTransportadora" valuePropName="checked">
              <Checkbox onChange={onChangeTmovTransportadora}>
                Incluir TMOV automaticamente no lote
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[0, 12]}>
          <Col span={24}>
            <Form.Item
              initialValue="TRANSPORTADORA"
              label="Selecione o tipo de lote onde a TMOV será incluída"
              name="tipoLote"
            >
              <Radio.Group onChange={onChangeTipoLote}>
                <Radio value="TRANSPORTADORA">Transportadora</Radio>
                <Radio value="MARKETPLACE">Marketplace</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[0, 12]}>
          <Col span={24}>
            <Form.Item name="anexoNfe" valuePropName="checked">
              <Checkbox onChange={onChangeAnexoNfe}>
                Anexar NF-e para embarcar motorista
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end" className="mt-20">
          <Button loading={loading} type="primary" htmlType="submit">
            Salvar
          </Button>
        </Row>
      </Form>
    </>
  );
}

Parametrizacao.propTypes = {
  cliente: PropTypes.objectOf(PropTypes.any).isRequired,
};
